/* Wild Apollo Redemption Page Behavior
   Email lookup, code apply, applied/expired resolution, plan chooser,
   PDP-detour links, quiz. Single source of truth for code + expiry validity. */

(function () {
  'use strict';

  // Plan chooser (Buy once / Subscribe) + cadence dropdown + direct-checkout buy.
  // Buy once is the DEFAULT (plan = 'once'); it must match the static markup in
  // wa-redemption-bottle-grid.liquid, which renders the buy-once state.
  // Subscribe attaches the cadence's selling_plan_id (from the section's
  // data-wa-plan-3..6 settings) to the cart line. The $40 is a one-time discount
  // CODE applied to the FIRST order on BOTH paths; the selling plan carries only
  // the ongoing $20 off, applied from order two onward (no plan discount on the
  // first order, so the $40 code does not stack on it). If a cadence's plan id
  // is somehow blank, Subscribe falls back to a one-time add.
  function initChooseAndBuy() {
    var root = document.querySelector('[data-wa-choose]');
    if (!root) return;

    var plan = 'once';
    var interval = 4;

    var planBtns = root.querySelectorAll('[data-wa-plan]');
    var intSelect = root.querySelector('[data-wa-int-select]');
    var intRow = root.querySelector('[data-wa-int-row]');
    var note = root.querySelector('[data-wa-note]');
    var noteSub = root.getAttribute('data-wa-note-sub') || '';
    var noteOnce = root.getAttribute('data-wa-note-once') || '';
    if (intSelect) interval = parseInt(intSelect.value, 10) || interval;

    // Expired-code mode: the grid sells at FULL price (gateBuyGrid handles the
    // card display). The heading and the buy-once note both promise the $40,
    // which an expired visitor will not get, so neutralize them here.
    var fullPrice = isUrlCodeExpired();
    if (fullPrice) {
      var headingEl = root.querySelector('.wa-choose__h');
      if (headingEl) headingEl.textContent = 'Choose your bottle';
    }

    function planIdForInterval(i) {
      return (root.getAttribute('data-wa-plan-' + i) || '').trim();
    }

    function render() {
      planBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-wa-plan') === plan);
      });
      if (intRow) intRow.style.display = (plan === 'sub') ? 'flex' : 'none';
      // The subscribe note ($20 off from order two) is true for ANY subscriber,
      // expired or not. The buy-once note promises the $40, so it hides in
      // expired full-price mode.
      if (note) {
        var noteText = (plan === 'sub') ? noteSub : (fullPrice ? '' : noteOnce);
        note.textContent = noteText;
        note.style.display = noteText ? '' : 'none';
      }

      document.querySelectorAll('[data-wa-buy]').forEach(function (c) {
        c.textContent = (plan === 'sub') ? 'Subscribe' : 'Buy once';
      });
      // First-order price is the static card price; the cadence line shows the
      // ongoing subscription price ($149 = $20 off) for orders two onward.
      document.querySelectorAll('[data-wa-cad]').forEach(function (c) {
        var recurring = c.getAttribute('data-wa-recurring') || '';
        c.textContent = (plan === 'sub')
          ? ('then ' + recurring + ' every ' + interval + ' months')
          : 'One-time purchase';
      });
      document.querySelectorAll('[data-wa-price-label]').forEach(function (c) {
        c.textContent = (plan === 'sub') ? 'first bottle' : 'one-time';
      });
    }

    planBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        plan = b.getAttribute('data-wa-plan');
        render();
      });
    });
    if (intSelect) {
      intSelect.addEventListener('change', function () {
        interval = parseInt(intSelect.value, 10) || interval;
        render();
      });
    }

    // Buy buttons on each card: add variant (+ selling plan if subscribing),
    // then go to checkout. With a valid code, it is already on the cart by this
    // point (preApplyDiscount). In expired mode the purchase proceeds at full
    // price with no code.
    document.querySelectorAll('[data-wa-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-wa-variant-id');
        if (!variantId) return;
        // UX lock: only the no-code state blocks buying (the discounted prices
        // shown are meaningless without a code). The EXPIRED state sells at
        // full price, so it proceeds. The real money protection is Shopify
        // validating the $40 code at checkout (a fake code yields no discount).
        if (!getActiveCode() && !isUrlCodeExpired()) { gateBuyGrid(); return; }
        var sellingPlanId = null;
        if (plan === 'sub') {
          var pid = planIdForInterval(interval);
          if (pid) {
            sellingPlanId = pid;
          } else {
            console.warn('[wa] No selling_plan_id set for ' + interval + '-month cadence; adding as one-time. Paste the redemption plan id into the WA Bottle Grid section settings.');
          }
        }
        addToCartAndCheckout(variantId, sellingPlanId, btn);
      });
    });

    render();
  }

  // Email lookup -> Klaviyo. Submitting fires a "Requested Redemption Code"
  // event to Klaviyo's client Events API for a profile with this email. The
  // code-resend flow in Klaviyo triggers on that metric: it reads the
  // profile's discovery_code / discovery_code_expires properties and emails a
  // link to /pages/redeem?code=...&expires=... The public key (site ID) comes
  // from the WA Credit Bar section setting via data-wa-klaviyo-key; with no
  // key set, the form reports lookup unavailable instead of pretending.
  // Success copy is deliberately noncommittal: never reveal whether an email
  // has an order attached.
  function initEmailLookup() {
    var form = document.querySelector('[data-wa-lookup-form]');
    if (!form) return;
    var input = form.querySelector('[data-wa-lookup-input]');
    var msg = form.querySelector('[data-wa-lookup-message]');
    var btn = form.querySelector('button[type="submit"]');
    var key = (form.getAttribute('data-wa-klaviyo-key') || '').trim();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') === -1) {
        msg.textContent = 'Please enter a valid email.';
        msg.classList.add('is-visible', 'is-error');
        return;
      }
      if (!key) {
        console.warn('[wa] Klaviyo public key not set on the WA Credit Bar section; lookup is not wired.');
        msg.textContent = 'Code lookup is not available right now.';
        msg.classList.add('is-visible', 'is-error');
        return;
      }

      if (btn) btn.disabled = true;
      msg.textContent = 'Sending...';
      msg.classList.add('is-visible');
      msg.classList.remove('is-error');

      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: { source: 'redeem_page_lookup', page: window.location.pathname },
              metric: { data: { type: 'metric', attributes: { name: 'Requested Redemption Code' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('klaviyo event failed: ' + res.status);
        msg.textContent = 'Check your inbox in a couple of minutes. We\'ll send your code to the email on your Discovery Set order.';
        msg.classList.remove('is-error');
        input.value = '';
      })
      .catch(function (err) {
        console.error(err);
        msg.textContent = 'Something went wrong. Please try again.';
        msg.classList.add('is-error');
      })
      .then(function () {
        if (btn) btn.disabled = false;
      });
    });
  }

  // Manual code entry: customer pastes a code they already have. Navigate to
  // /pages/redeem?code=CODE; on reload, applyActiveCodeState() reads the param
  // and flips the page into the applied state. (Liquid cannot read the param.)
  // Expiry for manual codes is unknown at this point (no &expires= in the URL);
  // it is validated for real at buy time (see addToCartAndCheckout).
  function initCodeApply() {
    var form = document.querySelector('[data-wa-code-form]');
    if (!form) return;
    var input = form.querySelector('[data-wa-code-input]');
    var msg = form.querySelector('[data-wa-code-message]');
    form.addEventListener('submit', function (e) {
      var code = (input.value || '').trim();
      if (!code) {
        e.preventDefault();
        msg.textContent = 'Please enter your code.';
        msg.classList.add('is-visible', 'is-error');
        return;
      }
      e.preventDefault();
      window.location.href = '/pages/redeem?code=' + encodeURIComponent(code);
    });
  }

  // --- Code + expiry resolution (single source of truth; Liquid can't read URL) ---
  // wa-redeem-pdp.liquid keeps its own tiny inline copy because it must run
  // synchronously before the PDP buy box paints, on a page that does not load
  // this file. Every other surface resolves validity through the helpers below.

  function getRawUrlCode() {
    var params = new URLSearchParams(window.location.search);
    return params.get('code') || '';
  }

  // Parse the &expires= value into a Date, or null if absent/unparseable.
  // A date-only value (YYYY-MM-DD) is treated as the END of that day in the
  // visitor's local time, so a code stays valid through its whole final day
  // regardless of timezone. Full datetimes and unix timestamps are honored too.
  function parseExpiry(raw) {
    if (!raw) return null;
    raw = ('' + raw).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      var d = new Date(raw + 'T23:59:59');
      return isNaN(d.getTime()) ? null : d;
    }
    if (/^\d+$/.test(raw)) {
      var n = parseInt(raw, 10);
      var ms = n < 1e12 ? n * 1000 : n;
      var du = new Date(ms);
      return isNaN(du.getTime()) ? null : du;
    }
    var dd = new Date(raw);
    return isNaN(dd.getTime()) ? null : dd;
  }

  // Raw expiry string from URL, falling back to the logged-in customer attr.
  function getRawExpires() {
    var params = new URLSearchParams(window.location.search);
    return params.get('expires') || document.body.getAttribute('data-wa-customer-expires') || '';
  }

  function getExpiryDate() {
    var params = new URLSearchParams(window.location.search);
    return parseExpiry(params.get('expires'));
  }

  // True only when the URL carries a code AND an expiry that is in the past.
  function isUrlCodeExpired() {
    if (!getRawUrlCode()) return false;
    var exp = getExpiryDate();
    if (!exp) return false; // no expiry info => validated at buy time instead
    return Date.now() > exp.getTime();
  }

  // The code we should actually apply anywhere. Empty if none, or if the URL
  // code is expired (so the dead code never reaches a CTA or checkout).
  function getActiveCode() {
    var urlCode = getRawUrlCode();
    if (urlCode) {
      if (isUrlCodeExpired()) return '';
      return urlCode;
    }
    var bodyCode = document.body.getAttribute('data-wa-customer-code');
    return bodyCode || '';
  }

  // --- Discount pre-apply (speed) ---
  // The code is known at page load, so attach it to the cart in the background
  // immediately (/cart/update.js supports a discount param since May 2025).
  // The buy click then only has ONE network call (add to cart) before
  // navigating straight to /checkout, instead of doing the discount work while
  // the visitor stares at a disabled button. States:
  //   'none'    - no active code on this page
  //   'pending' - background apply in flight
  //   'ok'      - code is on the cart; click can go straight to /checkout
  //   'failed'  - apply failed; click falls back to the /discount/ cookie route
  // NOTE: the attach succeeds (HTTP 200) even for dead codes, so 'ok' means
  // attached, not valid. Validity is adjudicated by &expires= for email links,
  // and at buy time against the populated cart for manually entered codes.
  var waDiscountState = 'none';
  var waDiscountPromise = null;

  function preApplyDiscount() {
    var code = getActiveCode();
    if (!code) {
      waDiscountState = 'none';
      return;
    }
    waDiscountState = 'pending';
    waDiscountPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('discount pre-apply failed');
      waDiscountState = 'ok';
    })
    .catch(function () {
      waDiscountState = 'failed';
    });
  }

  function showBlock(name) {
    ['lookup', 'applied', 'expired'].forEach(function (n) {
      var el = document.querySelector('[data-wa-block="' + n + '"]');
      if (el) el.hidden = (n !== name);
    });
  }

  // Resolve applied/expired on the client. If the URL code is expired, show the
  // expired block; the grid stays open at FULL price (see gateBuyGrid).
  // Otherwise, if a valid code exists, show applied, fill the code, and reveal
  // the status pill. The buy buttons read the active code at click time via
  // getActiveCode(), so there is no CTA rewrite step here anymore.
  function applyActiveCodeState() {
    var status = document.querySelector('[data-wa-status]');

    if (isUrlCodeExpired()) {
      showBlock('expired');
      if (status) status.hidden = true;
      return;
    }

    var code = getActiveCode();
    if (!code) return;

    showBlock('applied');
    var applied = document.querySelector('[data-wa-block="applied"]');
    if (applied) {
      var codeEl = applied.querySelector('[data-wa-applied-code]');
      if (codeEl) codeEl.textContent = code;
    }
    if (status) status.hidden = false;
  }

  // Product-details links -> redemption-mode PDP. When a live (non-expired)
  // code is active, rewrite each [data-wa-pdp-link] to carry wa_pdp=1 + code +
  // expires, so the PDP strips its buy box and shows the back button. Uses the
  // shared getActiveCode()/getRawExpires() above (no duplicate expiry logic).
  function initPdpLinks() {
    var code = getActiveCode();
    if (!code) return;
    var exp = getRawExpires();
    document.querySelectorAll('[data-wa-pdp-link]').forEach(function (a) {
      var url = a.getAttribute('data-wa-product-url') || a.getAttribute('href');
      var q = '?wa_pdp=1&code=' + encodeURIComponent(code);
      if (exp) q += '&expires=' + encodeURIComponent(exp);
      a.setAttribute('href', url + q);
    });
  }

  // Quiz: 2-axis match (warmth, earthiness) from real product notes.
  //   Big Sur     = bright + smooth
  //   Blue Ridge  = bright + earthy
  //   Key West    = warm + smooth
  //   Yellowstone = warm + earthy

  var BOTTLES = {
    'big-sur': {
      name: 'Big Sur',
      handle: 'wild-apollo-big-sur',
      variantId: '47162010435802',
      tag: 'FRESH | CITRUS | WOODY',
      notes: 'Frankincense | Vetiver | Sweet Orange | Geranium | Pink Pepper | Lavender',
      desc: 'Citrus and geranium on top, frankincense and vetiver underneath. Clean and easy to wear in the daytime.',
      axes: { warmth: 'bright', earth: 'smooth' }
    },
    'blue-ridge': {
      name: 'Blue Ridge',
      handle: 'wild-apollo-blue-ridge',
      variantId: '47077621563610',
      tag: 'HERBAL | AROMATIC',
      notes: 'Gum Benjamin | Geranium | Bergamot | Tonka Bean | Frankincense | Lavender | Cedarwood | Clary Sage',
      desc: 'Herbs and bergamot up front, cedar and resin in the dry-down. Cool, woodsy, outdoorsy.',
      axes: { warmth: 'bright', earth: 'earthy' }
    },
    'key-west': {
      name: 'Key West',
      handle: 'wild-apollo-key-west',
      variantId: '47077629755610',
      tag: 'BRIGHT | SWEET | FLORAL',
      notes: 'Sweet Orange | Amber | Bergamot | Cedarwood | Tonka Bean | Oakmoss | Jasmine',
      desc: 'Sweet orange and jasmine over amber and tonka. Warm and smooth. Reads as date-night more than office.',
      axes: { warmth: 'warm', earth: 'smooth' }
    },
    'yellowstone': {
      name: 'Yellowstone',
      handle: 'wild-apollo-yellowstone',
      variantId: '47077630574810',
      tag: 'EARTHY | WARM | RESINOUS',
      notes: 'Grapefruit | Cedarwood | Bergamot | Amber | Sweet Orange | Jasmine | Sandalwood',
      desc: 'Grapefruit and bergamot up top, sandalwood and cedar deep in the base. The warmest one we make.',
      axes: { warmth: 'warm', earth: 'earthy' }
    }
  };

  var state = { occasion: null, mood: null, noticeable: null, step: 0 };

  function axisFromAnswers() {
    var warmthScore = 0;
    var earthScore  = 0;

    if (state.occasion === 'office' || state.occasion === 'everyday') warmthScore -= 2;
    else if (state.occasion === 'night' || state.occasion === 'date') warmthScore += 2;

    if (state.mood === 'polished' || state.mood === 'clean') earthScore -= 2;
    else if (state.mood === 'rugged' || state.mood === 'outdoorsy') earthScore += 2;

    if (state.noticeable === 'close') { warmthScore -= 1; earthScore -= 1; }
    else if (state.noticeable === 'room') { warmthScore += 1; earthScore += 1; }

    return {
      warmth: warmthScore >= 0 ? 'warm' : 'bright',
      earth:  earthScore >= 0  ? 'earthy' : 'smooth',
      warmthScore: warmthScore,
      earthScore: earthScore
    };
  }

  function findBottleByAxes(warmth, earth) {
    for (var slug in BOTTLES) {
      var b = BOTTLES[slug];
      if (b.axes.warmth === warmth && b.axes.earth === earth) return slug;
    }
    return 'big-sur';
  }

  function determineRunnerUp(primarySlug, axes) {
    var primary = BOTTLES[primarySlug];
    var swapWarmth = Math.abs(axes.warmthScore) <= Math.abs(axes.earthScore);
    var newAxes;
    if (swapWarmth) {
      newAxes = {
        warmth: primary.axes.warmth === 'warm' ? 'bright' : 'warm',
        earth:  primary.axes.earth
      };
    } else {
      newAxes = {
        warmth: primary.axes.warmth,
        earth:  primary.axes.earth === 'earthy' ? 'smooth' : 'earthy'
      };
    }
    return findBottleByAxes(newAxes.warmth, newAxes.earth);
  }

  function renderResult() {
    var axes = axisFromAnswers();
    var primarySlug = findBottleByAxes(axes.warmth, axes.earth);
    var runnerUpSlug = determineRunnerUp(primarySlug, axes);
    var primary = BOTTLES[primarySlug];
    var runnerUp = BOTTLES[runnerUpSlug];

    var resultEl = document.querySelector('[data-wa-quiz-result]');
    if (!resultEl) return;

    resultEl.querySelector('[data-wa-result-name]').textContent = primary.name;
    resultEl.querySelector('[data-wa-result-tag]').textContent = primary.tag;
    resultEl.querySelector('[data-wa-result-desc]').textContent = primary.desc;

    var notesEl = resultEl.querySelector('[data-wa-result-notes]');
    if (notesEl) notesEl.textContent = primary.notes;

    var addBtn = resultEl.querySelector('[data-wa-result-add]');
    addBtn.setAttribute('data-variant-id', primary.variantId);
    addBtn.setAttribute('data-slug', primarySlug);
    addBtn.textContent = 'Add ' + primary.name + (getActiveCode() ? ', apply $40 credit' : '');

    var browseBtn = resultEl.querySelector('[data-wa-result-browse]');
    browseBtn.setAttribute('href', '/products/' + primary.handle);

    var runnerLink = resultEl.querySelector('[data-wa-result-runner-up]');
    runnerLink.querySelector('[data-wa-result-runner-name]').textContent = runnerUp.name;
    runnerLink.querySelector('[data-wa-result-runner-tag]').textContent = runnerUp.tag;
    runnerLink.setAttribute('href', '/products/' + runnerUp.handle);
  }

  function goToStep(stepIndex) {
    state.step = stepIndex;
    document.querySelectorAll('[data-wa-quiz-screen]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    var target = document.querySelector('[data-wa-quiz-screen="' + stepIndex + '"]');
    if (target) target.classList.add('is-active');

    var pills = document.querySelectorAll('[data-wa-quiz-pill]');
    pills.forEach(function (p, i) {
      p.classList.toggle('is-active', i <= stepIndex && stepIndex < 3);
    });

    if (stepIndex === 3) renderResult();
  }

  // Add a variant to the cart, then go to checkout.
  // sellingPlanId (string|null): when present, the line becomes a subscription
  // on that selling plan; when null, it is a one-time purchase.
  // Discount handling by entry path:
  //   - Email link (&expires= in URL): the URL adjudicates expiry and the code
  //     was pre-applied at page load, so the click is add -> /checkout, with
  //     the /discount/ cookie route as fallback if the pre-apply failed.
  //   - Manual entry (?code= with no &expires=): the URL knows nothing about
  //     expiry, but the cart reports per-code applicability once an eligible
  //     item is in it (verified empirically: active -> applicable true,
  //     expired/fake -> false; empty cart -> always false, hence checking only
  //     AFTER the add). Applicable -> /checkout. Not applicable -> undo the
  //     add and reload into the expired state instead of letting the visitor
  //     hit a full-price checkout surprise. Network failure fails OPEN to the
  //     /discount/ route; checkout remains the money guard either way.
  function addToCartAndCheckout(variantId, sellingPlanId, btnEl) {
    var originalText = btnEl.textContent;
    btnEl.dataset.waLabel = originalText; // remembered so bfcache restore can reset it
    btnEl.textContent = 'Adding...';
    btnEl.disabled = true;

    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function (added) {
      var code = getActiveCode();
      if (!code) {
        window.location.href = '/checkout';
        return;
      }
      btnEl.textContent = 'Opening checkout...';

      // Email-link fast path: expiry already adjudicated from the URL.
      if (getExpiryDate()) {
        var go = function () {
          if (waDiscountState === 'ok') {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
          }
        };
        if (waDiscountState === 'pending' && waDiscountPromise) {
          waDiscountPromise.then(go, go);
        } else {
          go();
        }
        return;
      }

      // Manual-entry path: validate the code against the now-populated cart.
      var addedKey = added && added.items && added.items[0] && added.items[0].key;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('discount check failed');
        return res.json();
      })
      .then(function (cart) {
        var match = (cart.discount_codes || []).filter(function (d) {
          return d.code && d.code.toUpperCase() === code.toUpperCase();
        })[0];
        if (match && match.applicable) {
          window.location.href = '/checkout';
        } else {
          revertToExpired(addedKey, code);
        }
      })
      .catch(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
    })
    .catch(function (err) {
      console.error(err);
      btnEl.textContent = originalText;
      btnEl.disabled = false;
      alert('Something went wrong. Please try again.');
    });
  }

  // A manually entered code turned out dead at buy time: undo the optimistic
  // add (so a full-price re-buy can't stack to quantity 2), strip the dead
  // discount from the cart (empty string removes all codes), then reload this
  // page with a past &expires= so the whole expired experience (credit-bar
  // message + ungated full-price grid) renders through the normal load-time
  // machinery.
  function revertToExpired(addedKey, code) {
    var removeLine = addedKey
      ? fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: addedKey, quantity: 0 })
        }).catch(function () {})
      : Promise.resolve();
    removeLine
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        }).catch(function () {});
      })
      .then(function () {
        window.location.replace('/pages/redeem?code=' + encodeURIComponent(code) + '&expires=1970-01-01');
      });
  }

  function initQuiz() {
    document.querySelectorAll('[data-wa-quiz-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelector('[data-wa-modal]').classList.add('is-open');
        document.body.style.overflow = 'hidden';
        state = { occasion: null, mood: null, noticeable: null, step: 0 };
        document.querySelectorAll('[data-wa-quiz-option]').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        goToStep(0);
      });
    });

    document.querySelectorAll('[data-wa-quiz-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    var modal = document.querySelector('[data-wa-modal]');
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    document.querySelectorAll('[data-wa-quiz-option]').forEach(function (option) {
      option.addEventListener('click', function () {
        var screen = option.closest('[data-wa-quiz-screen]');
        var stepIndex = parseInt(screen.getAttribute('data-wa-quiz-screen'), 10);
        var value = option.getAttribute('data-value');

        if (stepIndex === 0) state.occasion = value;
        if (stepIndex === 1) state.mood = value;
        if (stepIndex === 2) state.noticeable = value;

        screen.querySelectorAll('[data-wa-quiz-option]').forEach(function (o) {
          o.classList.remove('is-selected');
        });
        option.classList.add('is-selected');

        setTimeout(function () { goToStep(stepIndex + 1); }, 180);
      });
    });

    document.querySelectorAll('[data-wa-quiz-skip]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nextStep = parseInt(btn.getAttribute('data-next-step'), 10);
        goToStep(nextStep);
      });
    });

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-wa-result-add]');
      if (!addBtn) return;
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-variant-id');
      addToCartAndCheckout(variantId, null, addBtn);
    });
  }

  function closeModal() {
    var modal = document.querySelector('[data-wa-modal]');
    if (modal) modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Browser Back from checkout can restore this page from the bfcache with a buy
  // button still frozen on "Adding..." and disabled. Re-enable and relabel any
  // such buttons on bfcache restore. e.persisted is true only for that case, so
  // normal loads are untouched and no listeners get re-bound (no double-fire).
  function resetBuyButtons() {
    document.querySelectorAll('[data-wa-buy], [data-wa-result-add]').forEach(function (btn) {
      btn.disabled = false;
      if (btn.dataset.waLabel) btn.textContent = btn.dataset.waLabel;
    });
  }

  // Three grid states, resolved from the URL:
  //   valid code   -> unlocked, discounted display ($129 first / $149 recurring)
  //   EXPIRED code -> unlocked, FULL-PRICE display: the struck list price and
  //                   the "first bottle" label hide (CSS via .is-fullprice) and
  //                   the main price slot gets the plain list price. Buying
  //                   proceeds with no code attached.
  //   no code      -> locked: chooser hidden, buy buttons disabled. This is a
  //                   UX lock so we never show actionable discounted prices we
  //                   can't honor. Manually entered codes that LOOK valid here
  //                   are verified against the cart at buy time. Idempotent on
  //                   re-runs (bfcache).
  function gateBuyGrid() {
    var choose = document.querySelector('[data-wa-choose]');
    var buys = document.querySelectorAll('[data-wa-buy]');
    var cards = document.querySelectorAll('.wa-card');

    if (getActiveCode()) {
      if (choose) choose.removeAttribute('hidden');
      buys.forEach(function (btn) {
        btn.disabled = false;
        btn.classList.remove('is-disabled');
      });
      cards.forEach(function (c) {
        c.classList.remove('is-locked');
        c.classList.remove('is-fullprice');
      });
      return;
    }

    if (isUrlCodeExpired()) {
      if (choose) choose.removeAttribute('hidden');
      buys.forEach(function (btn) {
        btn.disabled = false;
        btn.classList.remove('is-disabled');
      });
      cards.forEach(function (c) {
        c.classList.remove('is-locked');
        if (!c.classList.contains('is-fullprice')) {
          c.classList.add('is-fullprice');
          var was = c.querySelector('.wa-card__price-was');
          var now = c.querySelector('.wa-card__price-now');
          if (was && now) now.textContent = was.textContent;
        }
      });
      return;
    }

    if (choose) choose.setAttribute('hidden', '');
    buys.forEach(function (btn) {
      btn.disabled = true;
      btn.classList.add('is-disabled');
      btn.textContent = 'Enter your code to unlock $40 off';
    });
    cards.forEach(function (c) { c.classList.add('is-locked'); });
  }

  function init() {
    preApplyDiscount();
    initChooseAndBuy();
    initEmailLookup();
    initCodeApply();
    applyActiveCodeState();
    gateBuyGrid();
    initPdpLinks();
    initQuiz();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { resetBuyButtons(); gateBuyGrid(); preApplyDiscount(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
